import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  isUploading: boolean;
  uploadProgress: number;
  currentFile: string | null;
  totalFiles: number;
  uploadedFiles: number;
}

const initialState: LoadingState = {
  isUploading: false,
  uploadProgress: 0,
  currentFile: null,
  totalFiles: 0,
  uploadedFiles: 0,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startUpload: (state, action: PayloadAction<{ totalFiles: number }>) => {
      state.isUploading = true;
      state.uploadProgress = 0;
      state.currentFile = null;
      state.totalFiles = action.payload.totalFiles;
      state.uploadedFiles = 0;
    },
    updateUploadProgress: (
      state,
      action: PayloadAction<{ progress: number; currentFile: string }>
    ) => {
      state.uploadProgress = action.payload.progress;
      state.currentFile = action.payload.currentFile;
    },
    incrementUploadedFiles: (state) => {
      state.uploadedFiles += 1;
      state.uploadProgress = (state.uploadedFiles / state.totalFiles) * 100;
    },
    finishUpload: (state) => {
      state.isUploading = false;
      state.uploadProgress = 0;
      state.currentFile = null;
      state.totalFiles = 0;
      state.uploadedFiles = 0;
    },
    resetLoading: (_state) => {
      return initialState;
    },
  },
});

export const {
  startUpload,
  updateUploadProgress,
  incrementUploadedFiles,
  finishUpload,
  resetLoading,
} = loadingSlice.actions;

export default loadingSlice.reducer;
